module.exports = __webpack_public_path__ + "static/media/verisign.fbbad64f.svg";